import {axiosService} from "../axios";

export const viewService = {

    fetchPreview: (id) => {
        return axiosService.get(`/api/views/${id}/preview`);
    },

    fetchData(fileId, tableName, page, size, filter, sort) {
        const sortPart = sort !== undefined ? `&sort=${sort}` : '';
        return axiosService.post(`/api/views/${fileId}/data/${tableName}?page=${page - 1}&size=${size}${sortPart}`, {filter: filter})
    },

    downloadData(fileId, tableName, filter, sort, format, columns) {
        const sortPart = sort !== undefined ? `&sort=${sort}` : '';
        return axiosService.post(`/api/views/${fileId}/data/${tableName}/download?${sortPart}`, {filter: filter, format: format, columns: columns}, {
            responseType: "blob"
        })
    },

    saveData(fileId, tableName, filter, sort, format, filename, columns) {
        const sortPart = sort !== undefined ? `&sort=${sort}` : '';
        return axiosService.post(`/api/views/${fileId}/data/${tableName}/save?${sortPart}`, {filter: filter, format: format, filename: filename, columns: columns});
    },

    explain: (fileId, tableName) => {
        return axiosService.get(`/api/views/${fileId}/ai/explain/${tableName}`);
    },

};
